export default [
  {
    path: '/sc-analysis',
    name: 'sc-analysis',
    meta: {
      name: '供应链分析',
      keepAlive: true,
      notLayout: true
    },
    component: () => import(/* webpackChunkName: "analysis" */ '@/views/sc-analysis/sc-analysis/index.vue')
  },
]
